import { Typography } from '@mui/material';

import type { TypographyProps } from '@mui/material';

interface TextLinesDisplayProps {
  lines: string[];
  typographyProps?: TypographyProps;
}

/**
 * Renders an array of text lines as individual Typography components.
 * Used for displaying multi-line content from factsheet version history
 * such as quality specifications, criteria, and calculation approaches.
 */
const TextLinesDisplay = ({ lines, typographyProps }: TextLinesDisplayProps) => {
  return (
    <>
      {lines.map((line, index) => (
        <Typography
          key={`${line.slice(0, 20)}-${index}`}
          sx={{
            fontSize: 16,
            fontWeight: 500,
            mb: 0.5,
            ...typographyProps?.sx
          }}
          {...typographyProps}
        >
          {line}
        </Typography>
      ))}
    </>
  );
};

export default TextLinesDisplay;
